var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddToCart = function SvgAddToCart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.611328,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.611328,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0759 19.8613H18.9259C18.7413 19.8622 18.5634 19.9302 18.4254 20.0527C18.2873 20.1752 18.1986 20.3438 18.1759 20.527L16.8446 32.527C16.8328 32.6315 16.8431 32.7374 16.8748 32.8377C16.9066 32.938 16.9591 33.0305 17.0289 33.1092C17.0988 33.1879 17.1844 33.251 17.2803 33.2945C17.3761 33.3379 17.48 33.3607 17.5852 33.3613H33.4165C33.5217 33.3607 33.6256 33.3379 33.7215 33.2945C33.8173 33.251 33.9029 33.1879 33.9728 33.1092C34.0426 33.0305 34.0951 32.938 34.1269 32.8377C34.1587 32.7374 34.1689 32.6315 34.1571 32.527L32.8259 20.527C32.8031 20.3438 32.7144 20.1752 32.5763 20.0527C32.4383 19.9302 32.2604 19.8622 32.0759 19.8613Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 22.8613V19.8613C21.75 18.8668 22.1451 17.9129 22.8483 17.2097C23.5516 16.5064 24.5054 16.1113 25.5 16.1113C26.4946 16.1113 27.4484 16.5064 28.1517 17.2097C28.8549 17.9129 29.25 18.8668 29.25 19.8613V22.8613",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddToCart);
export default ForwardRef;